'use client';

import {useEffect} from 'react';
import {consumeReloadMarkerFromUrl} from '@/lib/chunk-load-error';

/**
 * Räumt nach einem Chunk-Fehler-Reload auf: entfernt den Cache-Buster
 * `mg_reload` aus der URL und merkt sich, dass dieses Dokument bereits der
 * Reload war (Schleifenschutz). Rendert nichts, nutzt keine Router-Hooks —
 * braucht deshalb keine Suspense-Boundary unter cacheComponents.
 */
export function ChunkReloadCleanup() {
    useEffect(() => {
        consumeReloadMarkerFromUrl();
    }, []);

    return null;
}
